import {Button, message, Radio} from 'antd'
import React, {useState} from 'react'
import {Element, TypedElement} from '../../../../entities/project'
import {EditorCreatePlotArbitrary} from './EditorCreatePlotArbitrary'
import {EditorCreatePlotRect} from './EditorCreatePlotRect'
import {ToolType} from '../../toolLayers/CanvasToolManager'
import {useIntl} from 'react-intl'
import {BuildOutlined, GatewayOutlined} from '@ant-design/icons'

export type PlotShapeType = 'rect' | 'polygon' | null

export type EditorCreatePlotProps = {
  plot?: TypedElement
  plotShapeType: PlotShapeType
  onPlotShapeTypeChanged: (shapeType: PlotShapeType) => void
  tool?: ToolType
  onToolSelected: (tool: ToolType) => void
  onPlotUpdated: (updatedElement: TypedElement) => void
  transformerProps?: any
  onTransformerPropsChange?: (newProps: any) => void
}

export function EditorCreatePlot(props: EditorCreatePlotProps) {
  const [messageApi, contextHolder] = message.useMessage()
  const intl = useIntl()

  return (
    <div>
      <div className="editor-fields-name">{intl.formatMessage({id: 'choosePlotType'})}:</div>
      <Radio.Group
        value={props.plotShapeType}
        onChange={(e) => props.onPlotShapeTypeChanged(e.target.value)}
        className="editor-fields-radio-group"
      >
        <Radio.Button className="editor-fields-radio" value="rect" style={{height: 'auto'}}>
          <div className="editor-fields-radio-icon">
            <GatewayOutlined />
          </div>
          {intl.formatMessage({id: 'rect'})}
        </Radio.Button>
        <Radio.Button className="editor-fields-radio" value="polygon" style={{height: 'auto'}}>
          <div className="editor-fields-radio-icon">
            <BuildOutlined />
          </div>
          {intl.formatMessage({id: 'polygon'})}
        </Radio.Button>
      </Radio.Group>
      {props.plotShapeType === 'rect' ? (
        <EditorCreatePlotRect
          plot={props.plot}
          isToolSelected={props.tool === 'rect'}
          onToolSelected={() => props.onToolSelected('rect')}
          onPlotUpdated={props.onPlotUpdated}
        />
      ) : null}

      {props.plotShapeType === 'polygon' ? (
        <EditorCreatePlotArbitrary
          plot={props.plot}
          isToolSelected={props.tool === 'polygon'}
          onToolSelected={() => props.onToolSelected('polygon')}
          onPlotUpdated={props.onPlotUpdated}
          transformerProps={props.transformerProps}
          onTransformerPropsChange={props.onTransformerPropsChange}
        />
      ) : null}
    </div>
  )
}
